import ga from "@starter/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@starter/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackSearchSortedParameters extends TrackEventBaseParameters<null, "sort_type"> {}

const trackSearchSorted = (parameters: TrackSearchSortedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "search_sorted", ...parameters }, options);
};

export default trackSearchSorted;
